function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgWindpowerOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 11ZM8.3 1.1a.5.5 0 0 1 .1.7c-.693.924-1.173 2.226-1.48 3.334a18.536 18.536 0 0 0-.42 1.902l-.004.027v.007a.5.5 0 0 1-.99-.14L6 7l-.495-.07v-.005l.002-.008.005-.033a15.973 15.973 0 0 1 .099-.558c.072-.37.184-.882.345-1.46.317-1.142.837-2.59 1.644-3.666a.5.5 0 0 1 .7-.1Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7 1.1a.5.5 0 0 0-.1.7c.693.924 1.173 2.226 1.48 3.334a18.536 18.536 0 0 1 .42 1.902l.004.027v.007h.001a.5.5 0 0 0 .99-.14L10 7l.495-.07v-.005l-.002-.008-.005-.033a16.131 16.131 0 0 0-.099-.558 19.51 19.51 0 0 0-.345-1.46C9.727 3.724 9.207 2.276 8.4 1.2a.5.5 0 0 0-.7-.1ZM6.447 6.776a.5.5 0 0 1-.223.671c-.94.47-3.14 2.005-4.277 4.277a.5.5 0 1 1-.894-.448c1.264-2.528 3.664-4.193 4.724-4.723a.5.5 0 0 1 .67.223Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.553 6.776a.5.5 0 0 0 .223.671c.94.47 3.14 2.005 4.277 4.277a.5.5 0 1 0 .894-.448c-1.264-2.528-3.663-4.193-4.723-4.723a.5.5 0 0 0-.671.223ZM8.354 9.146a.5.5 0 0 1 0 .708c-.182.182-.522.398-.925.611-.419.222-.955.466-1.569.692-1.222.45-2.783.843-4.36.843a.5.5 0 0 1 0-1c1.423 0 2.862-.357 4.015-.782.574-.211 1.069-.437 1.446-.636.395-.21.618-.368.686-.436a.5.5 0 0 1 .707 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.647 9.146a.5.5 0 0 0 0 .708c.182.182.521.398.924.611.42.222.955.466 1.569.692 1.222.45 2.783.843 4.36.843a.5.5 0 1 0 0-1c-1.423 0-2.862-.357-4.014-.782a12.066 12.066 0 0 1-1.447-.636c-.395-.21-.617-.368-.685-.436a.5.5 0 0 0-.707 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgWindpowerOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgWindpowerOutlinedIcon);
export default Memo;